import { combineReducers } from 'redux';
import { createDuck } from 'helpers/duckTools';

export const uiDuck = createDuck('EMAIL_SUBSCRIPTION_FORM/UI', {});

const reducer = combineReducers({
  ui: uiDuck,
});

reducer.key = 'emailSubscription';

export { reducer };
